<template>
  <div >

    <!--<div style="position: relative; z-index: -1" width="100%">-->
      <!--<v-img src="../assets/images/content/math.png"  ></v-img>-->
    <!--</div>-->

    <Section
        background="black"
        class="image-bg"

    >
<!--       :style="{'background-image': `url(${require('../assets/images/content/background_math2.png')})`}"-->

      <div style="width:100%">
        <nav-bar></nav-bar>
      </div>


      <div class="main-heading" :style="sty_fold_height">
        <div class="heading-line">
          <div class="center  pt-0" :style="sty_fold_txt_1">
             Advizer Optimizes Dealer Performance
          </div>
<!--          <div class="center display-2">Sales | Marketing | F&I</div>-->
           <div class="center " :style="sty_fold_txt_2">
              Sales
              <svg width="10" :height="sty_dot_height" >
                 <circle r="5" cx="5" cy="15" fill="var(--color-primary)"></circle>
              </svg>

              Marketing

              <svg width="10" :height="sty_dot_height">
                 <circle r="5" cx="5" cy="15" fill="var(--color-primary)"></circle>
              </svg>

              F&I</div>

<!--          <div class="pt-6 pb-5">-->
<!--            <v-btn  to="/services#services-consulting" color="primary" @click.native="track('HomeBtnGuarantee')">-->
<!--              <span class="subtitle-1">We Guarantee Our Results</span>-->

<!--            </v-btn>-->
<!--          </div>-->

        </div>
      </div>

    </Section>
      <!-------------------------------------------easy as 123------------------------------------------------------------>


    <Section background="white" >

      <div class="bg-transparent-light">

        <v-container class="container-services">
           <div style="color: var(--color-primary);" :style="sty_123_title">
              Advizer Makes Optimizing Your Dealership as Simple as 1, 2, 3
           </div>




           <v-row class="ma-0  pb-5">



              <!--------------col for 1, 2, 3---------------------------------------->
              <v-col cols="12" sm="7">

                 <div class="numbered-item" :style="sty_123_dot_1">
                    <div class="numbered-line">
                       <div>
                          <svg width="30" height="30">
                             <circle r="12" cx="15" cy="15" fill="var(--color-primary)"></circle>
                             <text x="15" y="22" fill="white" font-size="15pt" font-weight="500" text-anchor="middle">1</text>
                          </svg>
                       </div>
                       <div :style="sty_123_txt_heading">
                          Analyzes Your Data
                       </div>
                    </div>
                    <div class="numbered-line-fine-print">
                       Advizer analyzes your sales, marketing and F&I data nightly using a computational
                       semantic network data model built specifically for your dealership
                    </div>
                 </div>


                 <div class="numbered-item" :style="sty_123_dot_2">
                    <div class="numbered-line">
                       <div>
                          <svg width="30" height="30">
                             <circle r="12" cx="15" cy="15" fill="var(--color-primary)"></circle>
                             <text x="15" y="22" fill="white" font-size="15pt" font-weight="500" text-anchor="middle">2</text>
                          </svg>
                       </div>
                       <div :style="sty_123_txt_heading">
                          Notifies You Of Any Issues It Finds
                       </div>
                    </div>
                    <div class="numbered-line-fine-print">
                       Advizer will notify you if it detects any performance issues via SMS text or email depending on
                       your preference
                    </div>
                 </div>


                 <div class="numbered-item" :style="sty_123_dot_3">
                    <div class="numbered-line">
                       <div>
                          <svg width="30" height="30">
                             <circle r="12" cx="15" cy="15" fill="var(--color-primary)"></circle>
                             <text x="15" y="22" fill="white" font-size="15pt" font-weight="500" text-anchor="middle">3</text>
                          </svg>
                       </div>
                       <div :style="sty_123_txt_heading">
                          Diagnoses What's Causing Them
                       </div>
                    </div>
                    <div class="numbered-line-fine-print">
                       Advizer shows you exactly what's causing an issue down to a specific marketing channel,
                       campaign, or even sales person.
                    </div>
                 </div>
              </v-col>


              <!--------------col for screenshot---------------------------------------->
              <v-col cols="12" sm="5">
                 <img src="../assets/images/content/product1.png" style="width: 100%">
              </v-col>


           </v-row>


           <v-row class="pt-5" style="margin-top: 50px; margin-left: 0px;">
              <v-spacer></v-spacer>
              <v-btn x-large to="/product" color="primary" @click.native="track('HomeLearnMore')">Learn More</v-btn>
              <v-spacer></v-spacer>
           </v-row>



        </v-container>
      </div>

    </Section>




    <!-------------------------------------------Why Advizer----------------------------------------------------------->


     <Section
         background="black"
         transparent
     >

        <div  class="bg-transparent-light pt-0"   style="width:100%;" >

           <div class="section-heading pt-10 pb-0" >Why Advizer?</div>

           <div class="section-sub-heading pt-2 pb-3" style="font-size: 1.8em">
              Insight in seconds.  Not hours.
           </div>

           <div style="width:100%; display: flex; flex-direction: column; align-items: center">
              <div class="why-text" :style="sty_why_container">

                 <p>
                    You already have the data you need to run your dealership optimally.
                    What you don't have is the time to go through that mountain of data spread across your
                     CRM, DMS, Google Analytics, Google Ads, Facebook, etc.

                 </p>


                 <p class="mt-7 mb-10">
                    Advizer was built by an auto industry veteran and a Wallstreet data scientist who realized that the
                    same technology used by the banking industry to analyze market data spread across multiple systems
                    could also solve the dealer's problem of connecting the dots across their multiple data sources.
                 </p>


                 <p class="mt-7 mb-10">
                    So why Advizer?  Because Advizer alerts you when an issue occurs and
                    gives you the insight to fix it in seconds, not hours.
                 </p>

              </div>
           </div>

        </div>


     </Section>


     <!-------------------------------------------How Advizer works---------------------------------------------------->

<!--    <Section background="black">-->
<!--      &lt;!&ndash;<div class="process-section">&ndash;&gt;-->
<!--        &lt;!&ndash;some text&ndash;&gt;-->
<!--      &lt;!&ndash;</div>&ndash;&gt;-->


<!--      <div class="">-->

<!--        <v-container class="container-services">-->
<!--          <v-row align="center" >-->
<!--            <v-col cols="12" sm="12" align="center">-->
<!--&lt;!&ndash;              <div class="section-heading pb-0">Business is</div>&ndash;&gt;-->
<!--              <div class="section-heading pt-0">People execute Processes using Technology</div>-->
<!--              <v-img-->
<!--                      max-width="700"-->
<!--                      position="center"-->
<!--                      src="../assets/images/content/people_process_tech_8x.png"-->
<!--              ></v-img>-->


<!--              <div class="section-heading pb-0">The Best Dealerships</div>-->
<!--              <div class="section-heading pt-0">Use Data to Optimize All Three</div>-->


<!--              &lt;!&ndash;<div class="process-section">&ndash;&gt;-->

<!--              &lt;!&ndash;Data&ndash;&gt;-->
<!--              &lt;!&ndash;</div>&ndash;&gt;-->

<!--            </v-col>-->

<!--          </v-row>-->



<!--        </v-container>-->
<!--      </div>-->

<!--    </Section>-->


     <Section background="white" >

        <div class="bg-transparent-light">
           <div class="section-heading pt-10 pb-10" :style="sty_how_works_title">How Does Advizer Work?</div>

           <v-container class="container-services">
<!--              <div style="color: var(&#45;&#45;color-primary); font-size: 25pt; font-weight: 500; margin-top: 40px; margin-bottom: 30px;">-->
<!--                 Advizer Makes Optimizing Your Dealership as Simple as 1, 2, 3-->
<!--              </div>-->




              <v-row class="ma-0  pb-5">



                 <!--------------col for 1, 2, 3---------------------------------------->
                 <v-col cols="12" sm="7">

                    <div class="numbered-item" :style="sty_123_dot_1">
                       <div class="numbered-line">
                          <div>
                             <svg width="30" height="30">
                                <circle r="12" cx="15" cy="15" fill="var(--color-primary)"></circle>
                                <text x="15" y="22" fill="white" font-size="15pt" font-weight="500" text-anchor="middle">1</text>
                             </svg>
                          </div>
                          <div :style="sty_123_txt_heading">
                             Give Advizer Access to Your Data
                          </div>
                       </div>
                       <div class="numbered-line-fine-print">
                          Give the Advizer platform to your data systems.  Practically this will involve creating a
                          login for us or working with your system vendor to get API access.
                       </div>
                    </div>


                    <div class="numbered-item" :style="sty_123_dot_2">
                       <div class="numbered-line">
                          <div>
                             <svg width="30" height="30">
                                <circle r="12" cx="15" cy="15" fill="var(--color-primary)"></circle>
                                <text x="15" y="22" fill="white" font-size="15pt" font-weight="500" text-anchor="middle">2</text>
                             </svg>
                          </div>
                          <div :style="sty_123_txt_heading">
                             We Create Your Unique Data Model
                          </div>
                       </div>
                       <div class="numbered-line-fine-print">
                          Our team will build a unique data model tailored to your dealership and the data you have as
                          well as work with you select which metrics you want to track in real time.
                       </div>
                    </div>


                    <div class="numbered-item" :style="sty_123_dot_3">
                       <div class="numbered-line">
                          <div>
                             <svg width="30" height="30">
                                <circle r="12" cx="15" cy="15" fill="var(--color-primary)"></circle>
                                <text x="15" y="22" fill="white" font-size="15pt" font-weight="500" text-anchor="middle">3</text>
                             </svg>
                          </div>
                          <div :style="sty_123_txt_heading">
                             Login or Just Wait to be Alerted
                          </div>
                       </div>
                       <div class="numbered-line-fine-print">
                          The Advizer app can be used anytime on desktop or mobile to check current performance.
                          Alternatively, just kick your feet up and relax.  If there's an issue, Advizer will alert
                          you with either a SMS text or an email.
                       </div>
                    </div>




                 </v-col>



                 <!--------------col for screenshot---------------------------------------->
                 <v-col  cols="12" sm="5">
                    <img src="../assets/images/content/product1.png" style="width: 100%">
                 </v-col>


              </v-row>


              <v-row class="pt-5" style="margin-top: 50px; margin-left: 0px;">
                 <v-spacer></v-spacer>
                 <v-btn x-large to="/product" color="primary" @click.native="track('HomeLearnMore')">Learn More</v-btn>
                 <v-spacer></v-spacer>
              </v-row>



           </v-container>
        </div>

     </Section>








    <!-------------------------------customer comments----------------------------------------------------------------->
<!--    <Section-->
<!--            background="black"-->
<!--            transparent-->
<!--            style="padding-top: 50px"-->
<!--    >-->

<!--      <div  class="bg-transparent-light pt-0"   style="width:100%;" >-->

<!--        <div class="section-heading pt-10 pb-0" >Our Customers</div>-->
<!--        <vueper-slides autoplay speed="7000" :slide-ratio="slide_ratio" class="no-shadow" :arrows="show_arrows" >-->
<!--          <vueper-slide-->
<!--                  v-for="(slide, i) in slides"-->
<!--                  :key="i"-->
<!--                  :title="slide.title"-->
<!--                  :content="slide.content"-->

<!--          >-->
<!--            <template v-slot:content>-->
<!--              <div class="slide-container">-->
<!--                <div class="slide-spacer"></div>-->

<!--                <div class="slide-content">-->
<!--                  <div>{{ slide.title }}</div>-->
<!--                  <div class="" style="font-style: italic"> "{{ slide.content }}"</div>-->
<!--                  <div  style="text-align: right"> {{ slide.author }}</div>-->
<!--                </div>-->
<!--                <div class="slide-spacer"></div>-->

<!--              </div>-->

<!--            </template>-->
<!--          </vueper-slide>-->
<!--        </vueper-slides>-->

<!--      </div>-->


<!--    </Section>-->



    <!-------------------------------------------------------contact us------------------------------------------------>
    <Section background="black" class="pt-10">

        <v-container fluid  style="max-width: 1000px">
          <v-row  justify="center" align="center">
            <v-col cols="12" md="6" align="center" >

              <div style="text-align: left">
                <p style="font-size: 1.5em">Want To Know More?  </p>

                <p style="font-size: 1.5em">Contact us and let us know more about your needs. </p>

<!--                <p style="font-size: 1.5em">Thanks!</p>-->
              </div>





            </v-col>


            <v-col cols="12" md="6" align="center">
              <Contact></Contact>

            </v-col>
          </v-row>
        </v-container>


    </Section>





    <!--<div class="process-section">-->

      <!--some extra space for the moment-->

    <!--</div>-->



  </div>

</template>






<style scoped lang="scss">


  .image-bg{
    background-size: cover;
    background-position: center;
  }


  .main-heading{
    //height: 450px; //set in dynamic style property
    display: flex;
    align-items: center;
    justify-content: center;

    }

  .heading-line{

    text-align: center;

  }


  .process-section{
    height: 700px;
    text-align: justify;

  }



  .bg-transparent-light{
    background: rgba(255, 255, 255, 0.05);
    width:100%;
  }


  .section-heading{
    font-size: 3em;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    text-align: center;

  }


  .section-sub-heading {
    font-size: 2em;
    font-weight: normal;
     width: 100%;
     text-align: center;
  }



  .container-services{
    max-width: 1200px;
    text-align: center;


    /*.service-heading{*/
      /*font-size: 2em;*/
      /*font-weight: normal;*/
    /*}*/

    .service-text{
      font-size: 1.0em;
      /*font-weight: lighter;*/
      line-height: 110%;
      text-align: justify;
      padding-top: 10px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  .colored-icon-text{
    font-size: 1.4em;
    /*font-size: 1.0em;*/
    /*text-align: left;*/
    text-align: justify;
    max-width: 800px;
  }










  .slide-container{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 200px;
  }

  .slide-content{
    margin: auto;
    padding-left: 20px;
    padding-right: 20px;
    max-width: 700px;

  }
  .slide-spacer{
    flex: 'flex-grow';
  }





//********settings for ease as 123 section***************

  .numbered-item{
     display: block;
     text-align: left;
  }


  .numbered-line{
     display: flex;
     justify-content: flex-start;
     align-items: center;

  }

  //.numbered-line-text{
  //   font-size: 17pt;
  //   font-weight: 500;
  //   margin-top: -7px;
  //   margin-left: 7px
  //}
  .numbered-line-fine-print{
     //padding-left: 10px;
     margin-top: -5px;
     margin-left: 5px;
     font-size: 12pt;
     max-width: 450px;
  }

//*******settings for why advizer ************************

  .why-text{
     padding: 10px;
     font-size: 1.5em;
     font-weight: 200;
     max-width: 800px;
     text-align: justify;

  }



</style>


<script>
// @ is an alias to /src
import Section from '@/components/Section.vue'
import Contact from '@/components/ContactForm.vue'
import navBar from '@/components/navBar.vue'

import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'


export default {
  name: 'home',
  components: {navBar, Section, Contact, VueperSlides, VueperSlide},
   data(){return {
      slide_duration: 12,
      slides: [
         {
            title: 'MagnetiQ Brands Agency',
            content: 'These guys are awesome.  I only explained about 80% of what I wanted, but they came back with a 110% solution',
            author: 'DJ, Owner'
         },
         {
            title: 'Ping Bear Studios',
            content: 'The Espy team reviewed our marketing analytics and implemented a solution which automated our social media, cutting our campaign deployment time by 80%',
            author: 'Anthony, CEO'
         },

         // {
         //    title: 'DealerKnows Training',
         //    content: 'The guys at Espy Data Science built a custom app for us under a very tight deadline and did a great job.  ' +
         //       'I look forward to working with them on future projects.',
         //    author: 'Bill, Founder'
         // },

      ]
   }},

   methods:{
      track (eventLabel, category='SiteNavigation') {
         this.$gtag.event('ButtonClick', {
            'event_category': category,
            'event_label': eventLabel,
         })
      }
   },

   computed:{

     //********responsive style properties for main fold **************************************
      sty_fold_height(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return 'height: 450px';
         }
         else {
            return 'height: 350px';
         }
      },

      sty_fold_txt_1(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return 'font-size: 39pt; font-weight: 400';
         }
         else {
            return 'font-size: 25pt; font-weight: 400';
         }
      },

      sty_fold_txt_2(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return 'font-size: 35pt; font-weight: 300';
         }
         else {
            return 'font-size: 21pt; font-weight: 300; margin-top: 15px;';
         }
      },

      sty_dot_height(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return '30';
         }
         else {
            return '25';
         }
      },


      //********responsive style properties for 1-2-3 section **************************************
      sty_123_title(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return 'font-size: 25pt; font-weight: 500; margin-top: 40px; margin-bottom: 30px;';
         }
         else {
            return 'font-size: 22pt; font-weight: 500; margin-top: 40px; margin-bottom: 10px;';
         }
      },

      sty_123_txt_heading(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return 'font-size: 17pt;font-weight: 500; margin-top: -7px; margin-left: 7px';
         }
         else {
            return 'font-size: 15pt;font-weight: 500; margin-top: -7px; margin-left: 7px';
         }
      },


      sty_123_dot_1(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return 'margin-top: 50px; margin-left: 0px;';
         }
         else {
            return 'margin-top: 0px; margin-left: 0px;';
         }
      },


      sty_123_dot_2(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return 'margin-top: 50px; margin-left: 60px;';
         }
         else {
            return 'margin-top: 30px; margin-left: 0px;';
         }
      },

      sty_123_dot_3(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return 'margin-top: 50px; margin-left: 120px;';
         }
         else {
            return 'margin-top: 30px; margin-left: 0px;';
         }
      },


      //*********how advizer works*****************************************
      sty_how_works_title(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return 'font-size: 25pt; font-weight: 500; margin-top: 40px; margin-bottom: 30px;';
         }
         else {
            return 'font-size: 22pt; font-weight: 500; margin-top: 40px; margin-bottom: -20px;';
         }
      },



      sty_why_container(){
         if (this.$vuetify.breakpoint.mdAndUp) {
            return '';
         }
         else {
            return 'padding-left:30px; padding-right: 30px';
         }
      },



      show_arrows(){
        if (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)) {
           return false;
        }
        else{
           return true;
        }
     },

     slide_ratio(){

        if (['xs'].includes(this.$vuetify.breakpoint.name)){
           return 0.7;
        }

        else if (['sm'].includes(this.$vuetify.breakpoint.name)){
           return 0.5;
        }
        else {
           return 0.3;
        }
     }
   },

   created(){
   }


}
</script>
